module.exports = __webpack_public_path__ + "img/Wavy_Edu-03_Single-11.0d107f22.jpg";